import React from 'react';
import { Box } from '@mui/material';

interface BaseTabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function BaseTabPanel(props: BaseTabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default BaseTabPanel;
